import axios from 'axios';
import {ENDPOINT} from "assets/constants";
import store from "../redux/store";

const createBackendServer = baseURL => {
    let api_token;
    let id;
    // let api_token = "xcYrmX7APtFcqzzHgeiDbcMYf1Yxv4cfZMfCtEMn8bpZChtzqtGX4s5aFvICQyQar0kEiVIHi0J6MIcw"; // Secretary
    // let api_token = "XnnBXJDzmLmJz37p4BtxnLEXOURUf4md0I53lP9IXMD8jJR5rvZyMImSe4GkhXPG1sgT5TGPzbB5GPJa"; // Standard


    store.subscribe(() => {
        const {user, fileManagerDialog} = store.getState().inbox;
        api_token = user?.api_token;
        id = user?.id;
        if (fileManagerDialog) {
            const domain = URL.split('.')[1];
            localStorage.setItem('id', domain + '-' + id);
        }
        if(!api_token){
            localStorage.clear();
            window.location = `${URL}/customer/login`
        }
    });

    const api = axios.create({
        baseURL,
        headers: {
            'Accept': 'application/json',
            // 'Content-Type': 'application/json',
            // 'Authorization': `Bearer ${api_token}`
        },
        timeout: 60 * 1000,
    });

    /*const setHeader = (key, value) => {
        // api.defaults.headers.post[key] = value;
        // api.defaults.headers.get[key] = value;
        // api.defaults.headers.put[key] = value;
        // api.defaults.headers.delete[key] = value;
        api.setHeader(key, value);
    };*/

    // USERS INFO
    const getUserApi = async body => api.get(`getuser?api_token=${api_token}`)
    // MESSAGES API
    const messagesApi = async ({queryKey}) => api.get(`${queryKey[0]}/${queryKey[1]}?page=${queryKey[2]}&perPage=${queryKey[3]}&sort=${queryKey[4]}&api_token=${api_token}`)
    // MEMBERS API
    const membersApi = async body => api.post(`customers?api_token=${api_token}`, body, {headers: {"Content-Type": "application/x-www-form-urlencoded"}});
    // MEMBERS OPTIONS API
    const memberOptionsApi = async body => api.get(`dropDownMenus?api_token=${api_token}`);
    // OPTIONS THEME, TITLE API
    const optionsApi = async body => api.get(`options?api_token=${api_token}`);
    // SIDEBAR LABELS API
    const labelsApi = async body => api.get(`labels?api_token=${api_token}`);
    // SEND MESSAGE
    const sendMessageApi = async body => api.post(`send?api_token=${api_token}`, body, {headers: {"Content-Type": "application/x-www-form-urlencoded"}});
    // MESSAGE API
    const messageApi = async ({queryKey}) => api.get(`${queryKey[0]}/${queryKey[1]}?api_token=${api_token}`);
    // SEND REPORT
    const sendReportApi = async (body) => api.post(`sendreport?api_token=${api_token}`, body, {headers: {"Content-Type": "application/x-www-form-urlencoded"}});
    // SENT LIST API
    const sendListApi = async (body) => api.post(`multiple_user?api_token=${api_token}`, body, {headers: {"Content-Type": "application/x-www-form-urlencoded"}});
    // Label Actions Like Inbox, Delete and Spam
    const labelActionsApi = async (body) => api.post(`actions?api_token=${api_token}`, body, {headers: {"Content-Type": "application/x-www-form-urlencoded"}})
    // USER LOGIN
    const userLoginApi = async body => api.post('login', body, {headers: {"Content-Type": "application/x-www-form-urlencoded"}});

    return {
        getUserApi,
        messagesApi,
        membersApi,
        messageApi,
        memberOptionsApi,
        labelsApi,
        sendMessageApi,
        optionsApi,
        sendReportApi,
        sendListApi,
        labelActionsApi,
        userLoginApi
    }
}

const apis = createBackendServer(ENDPOINT);

export default apis;